import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66b8f1b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "service-outage-modal__text mb-3" }, " После масштабного сбоя в сервисах Яндекса платформа Finch работает нестабильно. Мы уже устраняем неполадки и делаем всё возможное, чтобы как можно скорее восстановить привычную работу сервиса. ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "service-outage-modal__text mb-3" }, [
  /*#__PURE__*/_createElementVNode("b", null, "В качестве компенсации за возникшие неудобства мы бесплатно продлим доступ к платформе:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Пользователям с действующей подпиской"),
  /*#__PURE__*/_createTextVNode(" — добавим 30 дней к текущему оплаченному периоду. Дата следующего списания автоматически перенесётся на 30 дней."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Пользователям на пробном периоде"),
  /*#__PURE__*/_createTextVNode(" — продлим бесплатный доступ до 31 октября включительно. ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "service-outage-modal__text mb-3" }, [
  /*#__PURE__*/_createTextVNode(" Все изменения произойдут автоматически — никаких дополнительных действий не требуется."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Если у вас возникли вопросы, напишите нам на официальную почту службы поддержки: "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:support@finch.study" }, "support@finch.study"),
  /*#__PURE__*/_createTextVNode("."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Спасибо за понимание и терпение! ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "service-outage-modal__text mb-0" }, [
  /*#__PURE__*/_createTextVNode(" Мы обязательно сообщим, когда работа платформы полностью восстановится."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" С уважением,"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Команда Finch")
], -1))

import { ref } from 'vue';
import TariffNotificationModal from '../TariffNotificationModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceOutageModal',
  emits: ["hidden"],
  setup(__props, { expose: __expose, emit: __emit }) {

// Модалка о сбое в работе платформы (FINCH-2630). Чисто информационная:
// кнопка «Понятно» только закрывает окно, факт показа фиксирует хост по событию hidden.
const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();

const emit = __emit;

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

__expose({
    show: showModal,
    hide: hideModal,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TariffNotificationModal, {
    ref_key: "modalRef",
    ref: modalRef,
    title: "Важная информация о работе Finch",
    onButtonClick: hideModal,
    onHidden: _cache[0] || (_cache[0] = ($event: any) => (emit('hidden'))),
    "button-text": "Понятно",
    "max-width": 500
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4
    ]),
    _: 1
  }, 512))
}
}

})